// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import PropTypes from "prop-types";
import styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-j2sdnx-0"
})(["min-width:", ";max-width:", ";height:", ";"], _ref => {
  let {
    $size
  } = _ref;
  return $size;
}, _ref2 => {
  let {
    $size
  } = _ref2;
  return $size;
}, _ref3 => {
  let {
    $size
  } = _ref3;
  return $size;
});
const Pdf = _ref4 => {
  let {
    size = "1em",
    color = "currentColor",
    title,
    ...props
  } = _ref4;
  return /*#__PURE__*/_jsxs(SVG, {
    ...props,
    $size: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: title ? 'img' : 'presentation',
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, " ", /*#__PURE__*/_jsx("path", {
      fill: color,
      d: "M5.001 2.788A.895.895 0 0 0 5 2.83V11H3v8h2v2.07c0 .032.002.064.005.095A.75.75 0 0 0 5.75 22h14.5a.75.75 0 0 0 .748-.8.827.827 0 0 0 .002-.05v-13a.748.748 0 0 0-.063-.301.74.74 0 0 0-.217-.39l-5.4-5.2-.015-.014A.748.748 0 0 0 14.75 2h-9a.75.75 0 0 0-.749.788zM6.5 19v1.5h13V8.75h-4.7a.75.75 0 0 1-.75-.75V3.5H6.5V11H18v8H6.5zm0-3.523h-.053V17H5.54v-4.283H6.907c.52 0 .914.112 1.184.337.271.222.407.555.407.999 0 .23-.037.434-.111.612-.073.176-.18.324-.323.445-.14.12-.314.21-.521.273-.205.062-.44.094-.706.094H6.5zm0-2.016h-.053v1.271h.299c.281 0 .49-.054.627-.164.139-.109.208-.27.208-.483 0-.213-.059-.37-.176-.472-.115-.101-.297-.152-.545-.152H6.5zm6.36 1.356c0 .352-.051.663-.155.935-.101.271-.25.5-.448.685a1.95 1.95 0 0 1-.736.42A3.205 3.205 0 0 1 10.52 17H9.308v-4.283h1.344c.348 0 .659.048.932.143.275.094.507.232.694.413.19.18.334.4.434.66.1.26.15.554.15.884zm-2.162-1.356c.813 0 1.219.46 1.219 1.38 0 .94-.438 1.409-1.313 1.409h-.39v-2.79h.484zM13.748 17h.894v-1.693h1.453v-.742h-1.453v-1.104h1.561v-.744h-2.455V17z",
      fillRule: "evenodd",
      children: " "
    })]
  });
};
Pdf.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,
  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,
  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Pdf;